import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';

const SummaryVehicleInfo = ({ vehicleInfo }) => {
  return (
    <>
      {vehicleInfo.length === 0 && <h4>No vehicle info Selected</h4>}
      {vehicleInfo.length > 0 && (
        <Box between={3}>
          <Heading level="h4">Vehicle Info</Heading>
          <table>
            <Thead>
              <Tr>
                <Th>VIN</Th>
                <Th>Make</Th>
                <Th>Model</Th>
                <Th>Year</Th>
                <Th>No of vehicles</Th>
              </Tr>
            </Thead>
            <tbody>
              {vehicleInfo.map(details => {
                const { vin, make, model, year, quantity } = details;
                return (
                  <tr>
                    <Td style={{ background: vin ? '#fff' : '#f4f4f4' }}>
                      {vin}
                    </Td>
                    <Td style={{ background: make ? '#fff' : '#f4f4f4' }}>
                      {make}
                    </Td>
                    <Td style={{ background: model ? '#fff' : '#f4f4f4' }}>
                      {model}
                    </Td>
                    <Td style={{ background: year ? '#fff' : '#f4f4f4' }}>
                      {year}
                    </Td>
                    <Td>{quantity}</Td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Box>
      )}
    </>
  );
};

SummaryVehicleInfo.propTypes = {
  vehicleInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default SummaryVehicleInfo;
